// extracted by mini-css-extract-plugin
export var boxed = "Section-module--boxed--7e190";
export var fullWidth = "Section-module--fullWidth--e36ec";
export var ll = "Section-module--ll--4b4aa";
export var ls = "Section-module--ls--ea0ca";
export var section = "Section-module--section--2dbfa";
export var sl = "Section-module--sl--2edad";
export var ss = "Section-module--ss--a162c";